export enum PriceTaxType {
  WithoutTax = "WithoutTax",
  WithTax = "WithTax",
}
